// RoleProtectedRoute.tsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUserHasRole } from "../utils/authUtils";

interface RoleProtectedRouteProps {
    requiredRole: string | string[];
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ requiredRole }) => {
    const hasRole = useUserHasRole(requiredRole);
    return hasRole ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default RoleProtectedRoute;
